module.exports = __webpack_public_path__ + "static/media/snapshot4.1c7abd3e.png";